import moment from 'moment'
import Vue from 'vue'

Vue.filter('formatDate', function(value: Date, format:string='DD/MM/YYYY HH:mm') {
  if (value) {
    return moment(String(value)).format(format)
  }
})